import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-rapi-currency-input',
  templateUrl: './rapi-currency-input.component.html',
  styleUrls: ['./rapi-currency-input.component.css'],
})
export class RapiCurrencyInputComponent extends FieldType implements OnInit {
  formControl: FormControl;
  options: object = {
    prefix: '$ ',
    thousands: '.',
    decimal: ',',
    precision: 0,
  };

  ngOnInit(): void {}
}
